import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentGameAchievements = async (params) => {
  const res = await axios.middleware("/Social.asmx/PainelGame", {
    params,
  });
  return res[0].data;
};

export const useStudentGamePanel = ({ config, studentId } = {}) => {
  return useQuery({
    ...config,
    queryFn: () => getStudentGameAchievements({ alunoid: studentId }),
    queryKey: ["gameAchievements", { studentId, type: "game" }],
  });
};
